import React from 'react'
import { calculateEnclosingPeriod } from 'src/services/period'
import { NowContext } from 'src/contexts'
import useAlarm from './useAlarm'
import useNote from './useNote'
import usePeriodState from './usePeriodState'

/**
 * Hook providing a period calculated with period found in url and potential alarm or note from the url parameters
 */
export default function useEnclosingPeriod() {
  // get current alarm if any
  const alarm = useAlarm()

  // get current note if any
  const note = useNote()

  // get current period from url parameters
  const [{ from, to }] = usePeriodState()

  // return enclosing period
  const period = React.useMemo(
    () => calculateEnclosingPeriod(alarm || note || { startDate: from, endDate: to }, { from, to }),
    [alarm, note, from, to]
  )

  // get current time
  const { now } = NowContext.use()

  // let "to" boundary default to current time
  return React.useMemo(() => ({ to: now, ...period }), [period, now])
}
